<template>
  <v-container class="background black--text pb-lg-0" id="home-container">
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

    <v-row>
      <!-- hidden on large -->
      <v-col cols="12" class="col-lg-4 mr-lg-2 px-0 d-lg-none d-xl-none">
        <div class="topredbar"></div>
        <v-card elevation="2" tile class="">
          <v-card-title class="justify-center toc">
            Table of Contents
          </v-card-title>
          <v-card-text class="toc-links">
            <router-link to="/howtofile" target="_blank"
              >How to File a Report</router-link
            ><br />

            <router-link to="/howtofile" target="_blank"
              >Report Types</router-link
            >
            <br />
            <router-view></router-view>
            <a
              href="/howtofile?godeep=now"
              target="_blank"
              title="Tips for Reporting"
              >Tips for Reporting</a
            ><br />
            <a href="#" target="_blank" title="Other Services">Other Services</a
            ><br />

            <a
              href="https://renopd.com/VSU"
              target="_blank"
              title="Victim Services"
              >Victim Services</a
            ><br />
            <a
              href="https://records.renopd.com/"
              target="_blank"
              title="Records Requests"
              >Records Requests </a
            ><br />
            <a
              href="https://records.renopd.com/workcards"
              target="_blank"
              title="Fingerprints and Background Waivers"
              >Fingerprints and Background Waivers</a
            ><br />
            <a
              href="https://records.renopd.com/workcards"
              target="_blank"
              title="Privileged Business Licensing"
              >Privileged Business Licensing</a
            ><br />
            <a
              href="https://records.renopd.com/workcards"
              target="_blank"
              title="Felon or Sex Offender Registration"
              >Registration Forms (Felon/Sex Offender) </a
            ><br />
          </v-card-text>
        </v-card>
      </v-col>

      <!-- cards 1, 2 & 3 - this only displays on large -->
      <!-- card 2 - large only -->
      <v-row class="d-none d-lg-flex d-xl-flex lg-top-row">
        <v-col cols="12" class="col-lg-4 mr-lg-2 px-0">
          <div class="topredbar"></div>
          <v-card elevation="2" tile class="set-vcard-height">
            <v-card-title class="justify-center toc">
              Table of Contents
            </v-card-title>
            <v-card-text class="toc-links">
              <!-- <a href="#" target="_blank" title="How to File a Report"
                >How to File a Report</a
              ><br /> -->
              <router-link to="/howtofile" target="_blank"
                >How to File a Report</router-link
              ><br />

              <router-link to="/howtofile" target="_blank"
                >Report Types</router-link
              >
              <br />
              <router-view></router-view>

              <a
                href="/howtofile?godeep=now"
                target="_blank"
                title="Tips for Reporting"
                >Tips for Reporting</a
              ><br />

              <a href="#" target="_blank" title="Other Services"
                >Other Services</a
              ><br />
              <a
                href="https://renopd.com/VSU"
                target="_blank"
                title="Victim Services"
                >Victim Services</a
              ><br />
              <a
                href="https://records.renopd.com/"
                target="_blank"
                title="Records Requests"
                >Records Requests </a
              ><br />

              <a
                href="https://records.renopd.com/workcards"
                target="_blank"
                title="Fingerprints and Background Waivers"
                >Fingerprints and Background Waivers</a
              ><br />
              <a
                href="https://records.renopd.com/workcards"
                target="_blank"
                title="Privileged Business Licensing"
                >Privileged Business Licensing</a
              ><br />
              <a
                href="https://records.renopd.com/workcards"
                target="_blank"
                title="Felon or Sex Offender Registration"
                >Registration Forms (Felon/Sex Offender) </a
              ><br />
            </v-card-text>
          </v-card>
        </v-col>
        <v-row class="flex-column pr-lg-0 col-lg-8">
          <v-col class="px-0">
            <div class="topbar"></div>
            <v-card tile class="set-vcard-height">
              <v-card-title class="pb-lg-0">How Can We Help?</v-card-title>
              <div class="d-flex img-text">
                <v-col cols="12" class="col-lg-8 pt-lg-0">
                  <v-card-text class="help-text black--text pt-lg-0"
                    >Police Service Specialists are available to you in person
                    or by telephone at the Front Desk of the Reno Police
                    Deparment Main Station (455 E. 2nd St.) Monday through
                    Saturday from 8:00AM to 5:30PM. Give us a call at
                    <a href="tel:+17753342175">775-334-2175</a> for any
                    questions.</v-card-text
                  >
                  <v-card-title class="py-lg-0">What We Do</v-card-title>
                  <v-card-text class="help-text black--text pt-lg-0"
                    >The Front Desk is run by a team of highly trained and
                    skilled Police Services Specialists (PSS). PSS' are trained
                    to take crime reports from victims, survivors and witnesses
                    of all types of crimes. In addition to assisting members of
                    the community with in-person reporting, this team routinely
                    processes crime reports filed within the online reporting
                    system.</v-card-text
                  >
                </v-col>
                <v-col cols="12" class="col-lg-4">
                  <img src="../images/frontdesk.png" />
                </v-col>
              </div>
            </v-card>
          </v-col>

          <v-col class="px-0">
            <v-card>
              <!-- <v-card-title>What We Do</v-card-title>
              <v-card-text class="help-text black--text"
                >The Front Desk is run by a team of highly trained and skilled
                Police Services Specialists (PSS). PSS' are trained to take
                crime reports from victims, survivors and witnesses of all types
                of crimes. In addition to assisting members of the community
                with in-person reporting, this team routinely processes crime
                reports filed within the online reporting system.</v-card-text
              > -->
            </v-card>
          </v-col>
          <!-- card 3 - lg only -->
        </v-row>
      </v-row>

      <!-- card 2 -->
      <!-- hidden on large -->
      <v-col class="px-0 d-lg-none d-xl-none">
        <div class="topbar"></div>
        <v-card>
          <v-card-title>How Can We Help?</v-card-title>
          <v-card-text class="help-text black--text"
            >Police Service Specialists are available to you in person or by
            telephone at the Front Desk of the Reno Police Deparment Main
            Station (455 E. 2nd St.) Monday through Saturday from 8:00AM to
            5:30PM. Give us a call at
            <a href="tel:+17753342175">775-334-2175</a> for any
            questions.</v-card-text
          >
        </v-card>
      </v-col>
    </v-row>

    <!-- card 3 -->
    <!-- hidden on large -->
    <v-row id="card3" cols="12" class="d-lg-none d-xl-none">
      <v-col class="px-0">
        <div class="topbar"></div>
        <v-card>
          <v-card-title>What We Do</v-card-title>
          <div class="d-flex img-text">
            <v-col cols="12" class="col-lg-4 col-md-4">
              <img src="../images/frontdesk.png" />
            </v-col>
            <v-col cols="12" class="col-lg-8 col-md-8">
              <v-card-text class="help-text black--text"
                >The Front Desk is run by a team of highly trained and skilled
                Police Services Specialists (PSS). PSS' are trained to take
                crime reports from victims, survivors and witnesses of all types
                of crimes. In addition to assisting members of the community
                with in-person reporting, this team routinely processes crime
                reports filed within the online reporting system.</v-card-text
              >
            </v-col>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  .topredbar {
    height: 18px;
    background-color: #791e15;
  }

  .topbar {
    height: 18px;
    background-color: #708e92;
  }

  .toc-links {
    width: 100%;
  }

  .toc-links a {
    width: 100%;
    color: #039be5;
    text-transform: uppercase;
  }

  .help-text {
    font-weight: 400;
    font-size: 75%;
    line-height: 1.2rem;
  }

  .img-text {
    width: 100%;
    flex-wrap: wrap;
  }

  .img-text img {
    width: 100%;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  .img-text img {
    width: 100%;
  }
}

@media (min-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
  .lg-top-row {
    width: 100%;
    margin: 0 auto;
    flex-wrap: nowrap;
  }
  .set-vcard-height {
    height: 320px;
  }

  .img-text img {
    width: 100%;
  }
}

/* 1025 media q */
@media (min-width: 1025px) {
  .lg-top-row {
    width: 100%;
    margin: 0 auto;
    flex-wrap: nowrap;
  }

  .set-vcard-height {
    height: 300px;
  }

  .img-text img {
    width: 100%;
  }
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "frontdeskcards",
  mixins: [bus_common],
  data() {
    return {};
  },
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    init() {},
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
